// Localized relative time. Pass the `t` from useApp() for i18n; falls back to French.
export const timeAgo = (iso, t) => {
  if (!iso) return "";
  const tr = t || ((k, fb) => fb);
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return tr("time.now", "à l'instant");
  if (diff < 3600) return `${Math.floor(diff / 60)} ${tr("time.min", "min")}`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} ${tr("time.hour", "h")}`;
  return `${Math.floor(diff / 86400)} ${tr("time.day", "j")}`;
};

const STORY_LOCALE = { fr: "fr-FR", en: "en-GB", es: "es-ES", pt: "pt-PT" };

// Horodatage façon WhatsApp pour la visionneuse de stories : « Aujourd'hui, 11:41 » / « Hier, 20:05 » / « 12 juin, 09:30 ».
export const storyTimeLabel = (iso, lang = "fr", t) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const tr = t || ((k, fb) => fb);
  const locale = STORY_LOCALE[lang] || "fr-FR";
  const time = d.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
  const now = new Date();
  const dayStart = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const days = Math.round((dayStart(now) - dayStart(d)) / 86400000);
  if (days === 0) return `${tr("chat.today", "Aujourd'hui")}, ${time}`;
  if (days === 1) return `${tr("chat.yesterday", "Hier")}, ${time}`;
  return `${d.toLocaleDateString(locale, { day: "numeric", month: "long" })}, ${time}`;
};
